import MonitoringTemplatesContext from "contexts/RAGSettingsContext";
import useDefinedContext from "./useDefinedContext";

function useMonitoringTemplates() {
  const context = useDefinedContext(MonitoringTemplatesContext);

  return context;
}
export default useMonitoringTemplates;
